module.exports = __webpack_public_path__ + "media/images/Warm-Abstract-2-614d8910269a366bcf4609c4fe6cbfb5.png";